import { planRoute } from './plan';

export const allPlanRoutes = [planRoute()];
